import _map from 'lodash/map';

export const removeCookiesWithStringPrefix = (
  prefix: string,
  domain?: string | null,
  sameSite?: string | null,
): void => {
  const cookies = document.cookie.split(';');
  _map(cookies, (cookieUntrimmed: string): void => {
    const cookie = cookieUntrimmed.trim();
    if (cookie.startsWith(prefix)) {
      const [cookieName] = cookie.split('=');
      const cookieOptions = [
        domain ? `domain=${domain}` : '',
        sameSite ? `sameSite=${sameSite}` : '',
        'expires=Thu, 01 Jan 1970 00:00:01 GMT',
      ]
        .filter(Boolean)
        .join(';');
      document.cookie = `${cookieName}=; path=/; ${cookieOptions};`;
    }
  });
};

export const loadCookieFirst = (): void => {
  const w = window;
  const d = document;
  const l = (): void => {
    const s = d.createElement('script');
    s.type = 'text/javascript';
    s.src = 'https://consent.cookiefirst.com/sites/summariser.econsult.health-b5b54d21-a766-4866-b49b-56e287e44404/consent.js';
    const x = d.getElementsByTagName('script')[0];
    if (x.parentNode) {
      x.parentNode.insertBefore(s, x);
    }
  };

  if (document.readyState === 'complete') {
    l();
  } else {
    type WindowWithAttach = Window & {
      attachEvent?: (event: string, listener: () => void) => void;
    };
    const winWithAttach = w as WindowWithAttach;
    if (winWithAttach.attachEvent) {
      winWithAttach.attachEvent('onload', l);
    } else {
      w.addEventListener('load', l, false);
    }
  }
};
